import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestOrganizList } from 'modules/fetch/api';
const ACTIVE_ORGANIZ_GET = 'organization/ACTIVE_ORGANIZ_GET';
const ACTIVE_ORGANIZ_RESULT = 'organization/ACTIVE_ORGANIZ_RESULT';
const ACTIVE_ORGANIZ_RESET = 'organization/ACTIVE_ORGANIZ_RESET';
const ACTIVE_ORGANIZ_TITLE = 'organization/ACTIVE_ORGANIZ_TITLE';

export const organizationTitle = createAction(ACTIVE_ORGANIZ_TITLE);
export const organizationList = createAction(ACTIVE_ORGANIZ_GET);
export const organizationReset = createAction(ACTIVE_ORGANIZ_RESET);

const initialize = {
  organizTitle:'',
  organizList: [],
};

export function* getOrganizList(action) {
  try {
    const result = yield call(requestOrganizList, action.payload);
    yield put({ type: ACTIVE_ORGANIZ_RESULT, payload: result.data });
  } catch (err) {
    console.log(`consoleMessage:::${err.message}`);
  }
}

export function* organizSaga() {
  yield takeLatest(ACTIVE_ORGANIZ_GET, getOrganizList);
}

const organization = handleActions(
  {
    [ACTIVE_ORGANIZ_RESULT]: (state, { payload: organizList }) => {
      /* console.log('consoleMessage::::::::' + JSON.stringify(sentenceList)); */
      return { ...state, organizList };
    },
    [ACTIVE_ORGANIZ_TITLE]: (state, { payload: organizTitle }) => {
      return { ...state, organizTitle };
    },
    [ACTIVE_ORGANIZ_RESET]: state => ({ ...state, organizList: [] }),
  },
  initialize
);


export default organization;
